import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=22c719f6&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"
import style0 from "./ImageModal.vue?vue&type=style&index=0&id=22c719f6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c719f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c719f6')) {
      api.createRecord('22c719f6', component.options)
    } else {
      api.reload('22c719f6', component.options)
    }
    module.hot.accept("./ImageModal.vue?vue&type=template&id=22c719f6&scoped=true", function () {
      api.rerender('22c719f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ImageModal.vue"
export default component.exports